<template>
  <CContainer class="pt-5 mb-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-12 col-md-3 col-lg-4 col-xl-5">
        <h3 class="pl-3 mb-0 pb-0">Home</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-home" />
            Home
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow class="m-1">
      <CCol class="p-2" xl="12" style="text-align: center;">
        <h2><strong>Weekly Digest</strong></h2>
      </CCol>
    </CRow>
    <CRow class="m-1">
      <CCol class="p-2" xl="12">
        <p><strong>Total Vehicle: {{ totalVehicle }}</strong></p>
      </CCol>
    </CRow>
    <CRow class="m-1">
      <CCol class="p-2" xl="12">
        <apexchart width="100%" type="line" :options="options" :series="series"></apexchart>
      </CCol>
    </CRow>
    <!-- <CRow class="m-1">
      <CCol class="p-2" sm="6" lg="4" xl="3">
        <CCard class="custom-card">
          <CCardBody v-if="cards.isLoaded">
            <CCardTitle class="custom-card-title">{{ $helper.showData(cards.items.date.value, "longDate") }}</CCardTitle>
            <CCardSubtitle class="text-muted custom-card-subtitle">{{ cards.items.date.text }}</CCardSubtitle>
          </CCardBody>
          <CCardBody v-else>
            <CCardTitle><Skeleton type="rect" :width="100" :height="30" animation="fade"/></CCardTitle>
            <CCardSubtitle class="mb-2"><Skeleton type="rect" :width="150" :height="20" animation="fade"/></CCardSubtitle>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="p-2" sm="6" lg="4" xl="3">
        <CCard class="custom-card">
          <CCardBody v-if="cards.isLoaded">
            <CCardTitle class="custom-card-title">{{ $helper.showData(cards.items.visitor.value, "number") }}</CCardTitle>
            <CCardSubtitle class="text-muted custom-card-subtitle">{{ cards.items.visitor.text }}</CCardSubtitle>
          </CCardBody>
          <CCardBody v-else>
            <CCardTitle><Skeleton type="rect" :width="100" :height="30" animation="fade"/></CCardTitle>
            <CCardSubtitle class="mb-2"><Skeleton type="rect" :width="150" :height="20" animation="fade"/></CCardSubtitle>
          </CCardBody>
        </CCard>
      </CCol> 
      <CCol class="p-2" sm="6" lg="4" xl="3">
        <CCard class="custom-card">
          <CCardBody v-if="cards.isLoaded">
            <CCardTitle class="custom-card-title">{{ $helper.showData(cards.items.camera.value, "number") }}</CCardTitle>
            <CCardSubtitle class="text-muted custom-card-subtitle">{{ cards.items.camera.text }}</CCardSubtitle>
          </CCardBody>
          <CCardBody v-else>
            <CCardTitle><Skeleton type="rect" :width="100" :height="30" animation="fade"/></CCardTitle>
            <CCardSubtitle class="mb-2"><Skeleton type="rect" :width="150" :height="20" animation="fade"/></CCardSubtitle>
          </CCardBody>
        </CCard>
      </CCol> -->
    </CRow>
  </CContainer>
</template>


<script>
export default {
  name: 'Home',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    const periodFormat = /[0-9]{4}-[0-9]{2}-[0-9]{2}/g
    return {
      isLoading: true,
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      cards: {
        isLoaded: true, // NOTE: Set this to false in Production
        items: {
          date: { value: '', text: "Today" },
          visitor: { value: 0, text: "Visitors" },
          camera: { value: 0, text: "Cameras" },
        }
      },
      totalVehicle: "",
      periodFrom: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
      periodTo: today,
      minPeriod: '',
      maxPeriod: today,
      maxPeriodFrom: today,
      options: {
        chart: {
          id: 'vuechart-example'
        },
        yaxis: {
          title: {
            text: 'Vehicle',
          },
        },
        xaxis: {
          // categories: ["10 Oct 2022", "11 Oct 2022", "12 Oct 2022", "13 Oct 2022", "14 Oct 2022", "15 Oct 2022"],
          categories: [],
          title: {
            text: 'Date & Time',
            offsetY: 90
          },
        },
        legend: {
          position: 'top'
        }
      },
      series: [
        {
          name: 'Total Vehicle',
          data: []
        },
        {
          name: 'Total Car',
          data: []
        },
        {
          name: 'Total Bus',
          data: []
        },
        {
          name: 'Total Truck',
          data: []
        },
        {
          name: 'Total Motorcycle',
          data: []
        }
      ]
    }
  },
  methods: {

    getStatistics() {
      // URL builder
      let postUrl = "/digest"
      let params = {}
      // get content from date range
      let obj = {
        digest_type: "daily"
      }

      this.cards.isLoaded = false
      this.$axios.post(postUrl, obj).then(response => {
        if(response.status == 200){
          let chartData = response.data.data.chart
          let countData = response.data.data.total_count
          let seriesData = [
            {
              name: 'Total Vehicle',
              data: []
            },
            {
              name: 'Total Car',
              data: []
            },
            {
              name: 'Total Bus',
              data: []
            },
            {
              name: 'Total Truck',
              data: []
            },
            {
              name: 'Total Motorcycle',
              data: []
            }
          ]

          let optionsData = {
            chart: {
              id: 'vuechart-example'
            },
            yaxis: {
              title: {
                text: 'Vehicle',
              },
            },
            xaxis: {
              categories: [],
              title: {
                text: 'Date & Time',
                offsetY: 90
              },
            },
            legend: {
              position: 'top'
            }
          }

          for (var x = 0; x < chartData.all_vehicle.length; x++) {
            optionsData.xaxis.categories.push(this.$helper.showData(chartData.all_vehicle[x].datetime, "longDate"))
            seriesData[0].data.push(chartData.all_vehicle[x].count)
          }

          for (var x = 0; x < chartData.car.length; x++) {
            seriesData[1].data.push(chartData.car[x].count)
          }

          for (var x = 0; x < chartData.truck.length; x++) {
            seriesData[2].data.push(chartData.truck[x].count)
          }

          for (var x = 0; x < chartData.bus.length; x++) {
            seriesData[3].data.push(chartData.bus[x].count)
          }

          for (var x = 0; x < chartData.motorcycle.length; x++) {
            seriesData[4].data.push(chartData.motorcycle[x].count)
          }

          this.totalVehicle = this.$helper.thousandSeparator(countData.all_vehicle)
          this.series = seriesData
          this.options = optionsData
          this.isLoading = false
          
          // sessionStorage.setItem("filterHomePeriodFrom", this.periodFrom)
          // sessionStorage.setItem("filterHomePeriodTo", this.periodTo)

          // this.cards.items.date.value = response.data.data.today_date
          // this.cards.items.visitor.value = response.data.data.today_visitors
          // this.cards.items.camera.value = response.data.data.total_cameras
        }
        else{
          this.$helper.toastError(this, "Load Statistik Dasbor Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Statistik Dasbor Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Load Statistik Dasbor Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.cards.isLoaded = true
      })
    },
  },
  created(){
    this.getStatistics()
  }
}
</script>

<style>

</style>
